import ResourceTable from '../../../containers/core/ResourceTable';
import SimpleSearch from '../../core/SimpleSearch';

const StakeholderAddSearchTab = ({ contactsResource, search, showTable, onSelect, onSearch }) => {
  const handleSearch = () => {
    search.onSearch();
    onSearch();
  };

  const handleClear = () => {
    search.onChange('');
  };

  return (
    <>
      <SimpleSearch
        className="u-margin-top u-margin-bottom"
        {...search}
        canSearch={search?.query?.length > 0}
        onClear={handleClear}
        onSearch={handleSearch}
      />
      {showTable && <ResourceTable resource={contactsResource} onRowClick={onSelect} />}
    </>
  );
};

export default StakeholderAddSearchTab;
